<template>
  <div class="container" v-title data-title="整书阅读研究院">
    <div class="container-content">
      <img class="bg" src="../../assets/circle/teachingvideo.png" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'TeachingVideo',
  data() {
    return {
    };
  }
};
</script>

<style lang="scss" scoped>
// 父容器
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  background-color: #e8fbfcff;

  // 内容
  .container-content {
    display: block;
    position: relative;
    // 背景
    .bg {
      width: 100%;
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/circle/TeachingVideo.vue